import React from "react";
import iconCheck from "../assets/icons/Check.svg";
import { styleBlock } from "../styleBlock";
const style = styleBlock("supply-point-list--item");
const SupplyPointListItem = ({ data, selected, onClick, blue, className, translateFunc, }) => {
    var _a;
    const uniqAlt = data.address + ((_a = translateFunc === null || translateFunc === void 0 ? void 0 : translateFunc(data.iconAlt)) !== null && _a !== void 0 ? _a : "");
    const content = (React.createElement(React.Fragment, null,
        React.createElement("img", { className: style("icon"), width: 34, height: 34, src: data.icon, alt: uniqAlt }),
        React.createElement("div", { className: style("inner") },
            React.createElement("div", { className: style("title") }, data.title),
            React.createElement("div", { className: style("address") }, data.address)),
        React.createElement("img", { className: style("check"), width: 28, height: 28, src: iconCheck, alt: "", "aria-hidden": "true" })));
    return (React.createElement(React.Fragment, null,
        onClick ? (React.createElement("label", { className: style.mix(selected && "selected", className, blue && "blue") },
            React.createElement("input", { type: "checkbox", checked: selected, onChange: () => onClick(), className: style("input") }),
            React.createElement("span", { className: style("focus"), "aria-hidden": "true" }),
            content)) : (React.createElement("div", { className: style.mix(selected && "selected", className, blue && "blue") }, content)),
        data.error && React.createElement("div", { className: style("error") }, data.error)));
};
export default SupplyPointListItem;
//# sourceMappingURL=index.js.map